/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable no-unused-labels */
import { LoggerPlugin, LOGGER_NAME } from '@slardar/sdk-template';
import { PageviewMonitorPlugin, SamplePlugin, CustomPlugin, PAGEVIEW_MONITOR_PLUGIN_NAME, AjaxMonitorPlugin, AJAX_MONITOR_PLUGIN_NAME, FetchMonitorPlugin, FETCH_MONITOR_PLUGIN_NAME, TTIMonitorPlugin, TTI_MONITOR_PLUGIN_NAME, FMPMonitorPlugin, FMP_MONITOR_PLUGIN_NAME, HEATMAP_MONITOR_PLUGIN_NAME, } from '@slardar/sdk-web';
import { loadPluginsOnPageLoad } from './loader';
import { createMinimalBrowserClient } from './minimal';
import { PrecollectPlugin } from './plugins';
export var createBrowserClient = function (config) {
    if (config === void 0) { config = {}; }
    var client = createMinimalBrowserClient(config);
    // hack start heatmap需要服务端配置但是不希望异步加载文件
    client.loaded.push(HEATMAP_MONITOR_PLUGIN_NAME);
    // hack end
    loadPluginsOnPageLoad(client);
    SamplePlugin(client);
    PrecollectPlugin(client);
    debug: {
        // for debug
        LoggerPlugin(client);
        client.loaded.push(LOGGER_NAME);
    }
    CustomPlugin(client);
    // bundled collectors
    PageviewMonitorPlugin(client);
    client.loaded.push(PAGEVIEW_MONITOR_PLUGIN_NAME);
    AjaxMonitorPlugin(client);
    client.loaded.push(AJAX_MONITOR_PLUGIN_NAME);
    FetchMonitorPlugin(client);
    client.loaded.push(FETCH_MONITOR_PLUGIN_NAME);
    TTIMonitorPlugin(client);
    client.loaded.push(TTI_MONITOR_PLUGIN_NAME);
    FMPMonitorPlugin(client);
    client.loaded.push(FMP_MONITOR_PLUGIN_NAME);
    return client;
};
//# sourceMappingURL=client.js.map